import { UnreachableI18nCaseError } from '../utils/i18n-utils';
import { REQUEST_TYPES_MAP } from '../constants/request-types';
import LocaleFormattedMessage from './locales/LocaleFormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function RequestTypeLabel(props) {
  switch (props.requestType) {
    case REQUEST_TYPES_MAP.DELETE_REQUEST:
      return /*#__PURE__*/_jsx(LocaleFormattedMessage, {
        message: "app.requestTypes.DELETE_REQUEST"
      });
    case REQUEST_TYPES_MAP.EXPORT_REQUEST:
      return /*#__PURE__*/_jsx(LocaleFormattedMessage, {
        message: "app.requestTypes.EXPORT_REQUEST"
      });
    default:
      throw new UnreachableI18nCaseError(props.requestType);
  }
}
export default RequestTypeLabel;